<template>
	<div>
        <v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.message }}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
		</v-snackbar>
		<v-card flat v-if="positionTemplate">
			<v-card-text>
				<v-alert 
                        :value="true" 
						outline
                        type="info" 
                        class="mb-3 text-xs-left" 
                        >
                        You will be able to customise this template later.
                    </v-alert>
				<div class="header printOnly">
					<v-layout row wrap>
						<v-flex md3 class="text-xs-left">
							<div class="logo">
								<img :src="loggedInTenant.logoUrl" />
							</div>
						</v-flex>

						<v-flex md6 class="mt-3" style="text-align: center">
							<div style="margin-bottom: 5px" class="info-text">Position Description</div>
							<h1>{{ positionTemplate.title }}</h1>
						</v-flex>

						<v-flex md3 class="text-xs-left mt-3">
							<div class="header-right info-text">
								<div>Generated by Your HR System</div>
								<div>{{ new Date() | formatDate }}</div>
							</div>
						</v-flex>
					</v-layout>
				</div>

				<div class="content">
					<v-layout row wrap>
						<v-flex text-xs-left md8 sm12>
							<div class="text-xs-left">
								<h2 style="margin-bottom: 20px">Position Purpose</h2>
							</div>

							<p style="font-size: 13px; margin-bottom: 20px">{{ positionTemplate.description }}</p>
						</v-flex>
					</v-layout>

					<v-divider style="margin-bottom: 20px"></v-divider>

					<div v-for="(type, index) in pdItemsSorted" :key="index">
						<div class="text-xs-left">
							<h2 style="margin-top: 20px; margin-bottom: 10px">
								{{ type.typeFriendly }}
							</h2>
						</div>

						<div v-for="t in type.items" :key="t.id">
							<div class="text-xs-left">
								<h4 v-if="t.category !== 'N/A'" style="margin-top: 30px; margin-bottom: 20px; color: rgba(0, 0, 0, 0.54)">
									{{ t.category }}
								</h4>
							</div>
							<div v-for="s in t.items" :key="s.id" class="item">
								<v-layout row wrap style="margin-bottom: 5px">
									<v-flex text-xs-left md8 sm12>
										<div style="font-size: 13px">
											<div style="border-left-color: lightgray; padding-left: 10px; padding-right: 10px" :class="{ 'item-text': true }">
												<table>
													<tr>
														<td>
															<v-btn :class="{ 'item-btn': true, disabled: true }" fab small>
																<v-icon style="font-size: 14px">keyboard_arrow_right</v-icon>
															</v-btn>
														</td>
														<td>{{ s.item }}</td>
													</tr>
												</table>
											</div>

											<div v-for="outcome in s.outcomes" :key="outcome.id" style="margin-left: 20px">
												<div style="border-left-color: lightgray; padding-left: 10px; padding-right: 10px" :class="{ 'item-text': true }">
													<table>
														<tr>
															<td>
																<v-btn :class="{ 'item-btn': true, disabled: true }" fab small>
																	<v-icon style="font-size: 14px">keyboard_arrow_right</v-icon>
																</v-btn>
															</td>
															<td>{{ outcome.outcome }}</td>
														</tr>
													</table>
												</div>
											</div>
										</div>
									</v-flex>
								</v-layout>
							</div>
						</div>

						<v-divider style="margin-bottom: 20px"></v-divider>
					</div>
				</div>
			</v-card-text>
		</v-card>

		<loading-modal v-if="isLoading" loading-text="Loading Position Template..." />

		<v-footer color app height="55" class="noPrint" v-if="loggedInEmployee.isAdmin">
			<v-spacer></v-spacer>
			<footer-back-btn @click="backBtnClicked" />
		</v-footer>

	</div>
</template>

<script>
	import LoadingModal from '@/components/LoadingModal';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import { mapGetters } from 'vuex';

	export default {
		components: {
			LoadingModal
		},
		props: {
			id: {
				required: true,
				type: String
			}
		},
		mixins: [typeFriendlyMixin],
		data() {
			return {
				positionTemplate: null,
                isLoading: false,
                snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
			};
		},
		created() {
			this.isLoading = true;
			this.$store.dispatch('positionTemplates/getGlobalTemplateById', this.id).then(
				(positionTemplate) => {
					this.isLoading = false;
					this.positionTemplate = positionTemplate;
				},
				(error) => {
					this.isLoading = false;
					this.showSnackbar('An error occurred loading position template', true);
				}
			);
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			}),
			pdItemsSorted() {
				// group by type
				let groupedByType = _.groupBy(this.positionTemplate.positionItems, 'type');
				let result = [];

				for (let type in groupedByType) {
					result.push({
						type: type,
						typeFriendly: this.getTypeFriendly(type, true),
						items: []
					});

					// group by category
					let groupedByCategory = _.groupBy(groupedByType[type], 'category');

					for (let category in groupedByCategory) {
						result[result.length - 1].items.push({
							category: category,
							items: groupedByCategory[category]
						});
					}
				}

				let sortOrder = [1, 2, 5, 0, 3, 4];
				let resultsOrdered = [];
				for (let i = 0; i < sortOrder.length; i++) {
					for (let x = 0; x < result.length; x++) {
						if (result[x].type == sortOrder[i]) {
							resultsOrdered.push(result[x]);
						}
					}
				}

				return resultsOrdered;
			}
		},
		methods: {
			printClick() {
				window.print();
			},
			backBtnClicked() {
				window.history.back();
			},
			backBtnClicked() {
				this.$router.push({ name: 'positionTemplates' });
            },
            showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			},
		}
	};
</script>

<style scoped>
	.header {
		min-height: 100px;
		margin-bottom: 25px;
	}
	.header .header-right {
		text-align: right;
	}
	.header h1 {
		font-size: 1.7em;
	}
	.content {
		text-align: left;
	}
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}
	.logo img {
		max-height: 100px;
		max-width: 220px;
	}
	.pd-signatures {
		margin-top: -15px;
		text-align: right;
	}
</style>